import React, { useState } from 'react';
import ProjectCard from './ProjectCard';
import galleryImage1 from '@/images/gallery-1.png';
import galleryImage2 from '@/images/gallery-2.png';
import galleryImage3 from '@/images/gallery-3.png';
import galleryImage4 from '@/images/gallery-4.png';
import galleryImage5 from '@/images/gallery-5.png';
import galleryImage6 from '@/images/gallery-6.png';
import galleryImage7 from '@/images/gallery-7.png';
import galleryImage8 from '@/images/gallery-8.png';
import galleryImage9 from '@/images/gallery-9.png';
import galleryImage10 from '@/images/gallery-10.png';
import galleryImage11 from '@/images/gallery-11.png';

// Sample projects data
const projects = [
  // Added category for tab filtering
  {
    id: 1,
    category: 'web design',
    title: 'Restuarant Landing page',
    description: 'A fully responsive restaurant landing page built with React.',
    imageUrl: galleryImage1,
    tags: ['Figma','React', 'MUI'],
    projectUrl: 'https://www.behance.net/gallery/213011053/Restaurant-website-landing-page'
  },
  {
    id: 2,
    category: 'mobile design',
    title: 'Ice and Beverages App',
    description: 'An instant app design in Figma for an ice and beverage app, featuring a splash screen, login, register, and home page — all with a refreshing and modern look.',
    imageUrl: galleryImage2,
    tags: ['Figma'],
    projectUrl: 'https://dribbble.com/shots/21521512-UI-design-for-Ice-and-Beverages-App'
  },
  {
    id: 3,
    category: 'mobile design',
    title: 'Music Player App - Neumorphism Design',
    description: 'A music player mobile app design inspired by neumorphism, created in Figma with soft shadows, subtle depth, and a sleek modern interface.',
    imageUrl: galleryImage3,
    tags: ['Figma'],
    projectUrl: 'https://dribbble.com/shots/21521848-Redesigned-Music-Player-App-Neumorphism-UI'
  },
  {
    id: 4,
    category: 'web design',
    title: 'Dashboard design',
    description: 'A clean, minimalistic dashboard design created using Figma.',
    imageUrl: galleryImage4,
    tags: ['Figma'],
    projectUrl: 'https://www.behance.net/gallery/213018069/Dashboard-design'
  },
  {
    id: 5,
    category: 'web design',
    title: 'Aura Enchantment',
    description: 'A beautiful, minimalistic salon landing page designed in Figma.',
    imageUrl: galleryImage5,
    tags: ['Figma'],
    projectUrl: 'https://www.behance.net/gallery/213893889/Aura-Enchantment'
  },
  {
    id: 6,
    category: 'web design',
    title: 'Planto - Rooted in greenery',
    description: 'A plant-selling landing page design crafted in Figma with a fresh and user-friendly layout.',
    imageUrl: galleryImage6,
    tags: ['Figma'],
    projectUrl: 'https://www.behance.net/gallery/213006511/Planto-Rooted-in-greenery'
  },
  {
    id: 7,
    category: 'web design',
    title: 'IntDesign',
    description: 'A minimalistic and simple interior design company landing page, designed in Figma to showcase projects and services elegantly.',
    imageUrl: galleryImage7,
    tags: ['Figma'],
    projectUrl: 'https://www.behance.net/gallery/213010743/IntDesign'
  },
  {
    id: 8,
    category: 'web design',
    title: 'Glassmorphism Card Design',
    description: 'A simple glassmorphism-style card design created in Figma, featuring soft transparency, blur effects, and a clean modern look.',
    imageUrl: galleryImage8,
    tags: ['Figma'],
    projectUrl: 'https://dribbble.com/shots/21756114-Glassmorphism-Card'
  },
  // {
  //   id: 9,
  //   category: 'mobile design',
  //   title: 'Eatmore-Food-delivery-UI Design',
  //   description: 'A productivity application with drag-and-drop tasks and team collaboration features.',
  //   imageUrl: galleryImage9,
  //   tags: ['Figma'],
  //   projectUrl: 'https://www.behance.net/gallery/220274087/Eatmore-Food-delivery-UI'
  // },
  {
    id: 10,
    category: 'mobile design',
    title: 'Root Detect',
    description: 'A mobile app interface designed in Figma to detect whether a device is rooted or not, featuring a simple, user-friendly layout with clear status indicators.',
    imageUrl: galleryImage10,
    tags: ['Figma'],
    projectUrl: 'https://www.behance.net/gallery/220287683/Root-Detect-Lets-begin-to-detect-your-device'
  },
  {
    id: 11,
    category: 'case studies',
    title: 'Quick bin',
    description: 'A case study focused on providing a digital solution to Sri Lanka’s garbage collection problem, designed using Figma and FigJam. It showcases user research, problem analysis, journey mapping, and a clean, functional mobile UI for scheduling pickups, reporting issues, and tracking garbage collection in real-time.',
    imageUrl: galleryImage11,
    tags: ['Figma'],
    projectUrl: 'https://www.behance.net/gallery/227993059/QuickBin-UX-Case-Study-for-Easy-Trash-Pickup'
  },
];

const WorksSection = () => {
  const tabs = ['web design', 'mobile design', 'case studies'];
  const [activeTab, setActiveTab] = useState<string>(tabs[0]);
  const filteredProjects = projects.filter(p => p.category === activeTab);

  return (
    <section id="works" className="py-24">
      <div className="container mx-auto">
      <h5 className=' text-primary mb-6 font-Urbanist font-medium tracking-widest text-xl'>My Works</h5>
        <h2 className="section-heading font-light tracking-widest sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">Tadaa!Take a Peek at What I’ve Crafted!😍</h2>
       <p  className="text-muted-foreground mb-6 text-lg tracking-widest">Here’s a collection of projects I’ve poured my creativity, logic, and love for UX into. From wireframes to polished interfaces, each piece reflects my journey in solving real problems through thoughtful design. Dive in and explore the pixels that tell my story.</p> 
        <div className="text-center flex justify-center gap-20 mb-6">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-2 transform transition-colors duration-300 ${activeTab === tab ? 'border-b-2 border-[hsl(var(--primary))] text-[hsl(var(--primary))]' : 'text-gray-600'}`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, index) => (
            <div 
              key={project.id} 
              data-animation={`animate-fade-in-up`} 
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <ProjectCard 
                title={project.title}
                description={project.description}
                imageUrl={project.imageUrl}
                tags={project.tags}
                projectUrl={project.projectUrl}
              />
            </div>
          ))}
        </div>
        <div className="flex justify-end mt-6">
          <a href="https://www.behance.net/thamodyranasin" className="text-blue-500 hover:underline transition-colors duration-200">View More</a>
        </div>
      </div>
    </section>
  );
};

export default WorksSection;
